<template>
  <div>
    <b-form-group
      v-if="selectedTypes.includes('email') || selectedTypes.includes('push')"
      id="input-group-subject"
      label="Email Subject"
      label-for="input-1"
    >
      <b-form-input
        id="input-1"
        v-model="subject"
        required
        placeholder="Enter subject"
      />
    </b-form-group>

    <b-form-group
      id="input-group-custom-body"
      label="Custom body"
      label-for="input-2"
    >
      <b-form-input
        id="input-2"
        v-model="message"
        required
        placeholder="Custom body"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      v-if="selectedTypes.includes('email')"
      id="input-group-email"
      label="Email template"
      label-for="input-3"
    >
      <b-form-select
        v-model="selectedTemplate"
        :options="templateMailOptions"
        @change="handleTemplateChange"
      />
    </b-form-group>

    <b-form-group label="select a method to send notifications">
      <b-form-checkbox-group
        id="checkbox-slots"
        v-model="selectedTypes"
        :options="notifyOptions"
        name="checkbox-options-slots"
      >
      </b-form-checkbox-group>
    </b-form-group>
    <b-button
      v-if="!isLoading"
      block
      variant="success"
      @click="send()"
    >
      SEND
    </b-button>
    <b-button v-else disabled block variant="success">
      <b-spinner small type="grow"></b-spinner>
      Loading...
    </b-button>
  </div>
</template>
<script>
// import firebase from "firebase";
import sendNotification from "@/services/sendNotification";
import config from "@/assets/_config.json";
export default {
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      config,
      subject: "",
      isLoading: false,
      message: "",
      selectedTypes: [],
      notifyOptions: [
        { text: "Email", value: "email" },
        { text: "Push", value: "push" },
        { text: "SMS", value: "sms" },
        { text: "Whatsapp", value: "whatsapp", disabled: true },
        { text: "Messenger", value: "messenger", disabled: true },
        { text: "Voice", value: "voice", disabled: true },
        { text: "Slack", value: "slack", disabled: true },
        { text: "Apple Watch", value: "watch-apple", disabled: true },
        { text: "Notification", value: "notification", disabled: true }
      ],
      selectedTemplate: null
    };
  },
  computed: {
    templateMailOptions() {
      const tplOptions = [];

      this.config.mail.forEach(section => {
        const options = [];

        if (section.tpls && Array.isArray(section.tpls)) {
          section.tpls.forEach(tpl => {
            const thisOption = {
              text: tpl.name,
              value: tpl
            };
            options.push(thisOption);
          });
        }
        tplOptions.push({ label: section.type, options: options });
      });

      if (tplOptions.length > 0) {
        return [{ text: "Please select an mail template", value: null }].concat(
          tplOptions
        );
      }

      return tplOptions;
    },
    validation() {
      let validation = true;
      if (this.selectedTypes.length === 0) {
        validation = false;
      } else {
        if (
          this.selectedTypes.includes("email") &&
          (this.subject === "" || this.message === "")
        ) {
          validation = false;
        } else if (this.message === "") {
          validation = false;
        }
      }

      return validation;
    }
  },
  methods: {
    handleTemplateChange() {
      //console.log(`TEMPLATE: ${JSON.stringify(this.selectedTemplate)}`);
      if (this.selectedTemplate && this.selectedTemplate.subject) {
        this.subject = this.selectedTemplate.subject;
      } else {
        this.subject = "";
      }
    },
    send() {
      this.isLoading = true;
      sendNotification(
        this.subject,
        [this.data.userRef],
        this.selectedTypes,
        this.message,
        "HeartBeatFam",
        this.selectedTemplate.id
      )
        .then(res => {
          this.isLoading = false;
          this.$store.dispatch("user/showNotification", {
            title: "Success",
            description: "Notifications are sent successfully.",
            variant: "success"
          });
          //console.log("sent", res);
        })
        .catch(error => {
          this.isLoading = false;
          this.$store.dispatch("user/showNotification", {
            title: error,
            description: error.message,
            variant: "danger"
          });
        });
    }
  }
};
</script>
